"use client";
import React from "react";

const BestSellersGallery = ({ data }: any) => {
  if (!data || !data.images?.data?.length) return null;

  const tilt = [
    "rotate-[-3deg]",
    "rotate-[2deg]",
    "rotate-[-1deg]",
    "rotate-[3deg]",
    "rotate-[-2deg]",
  ];

  return (
    <>
      <div className="relative w-full py-8 md:py-12 bg-[#ad2c8f0a] overflow-hidden">

        {/* Background Soft Shapes */}
        {data?.backgroundImage && (
          <div className="absolute inset-0 w-full h-full pointer-events-none opacity-20 md:opacity-30">
            <img
              src={data.backgroundImage}
              className="w-full h-full object-cover"
              alt=""
            />
          </div>
        )}

        {/* Images Row */}
        <div
          className="
            relative z-10 
            flex justify-center 
            gap-4 md:gap-6 
            px-4 sm:px-6 
            flex-wrap md:flex-nowrap
          "
        >
          {data.images.data.map((img: any, idx: number) => {
            const url = img?.attributes?.url || "";

            return (
              <div
                key={img.id || idx}
                className={`
                  bg-white shadow-md p-2 sm:p-3 rounded-sm border border-gray-200
                  ${tilt[idx % tilt.length]}
                  w-[140px] sm:w-[180px] md:w-[220px]
                `}
              >
                <div className="overflow-hidden rounded-sm">
                  <img
                    src={url}
                    className="w-full h-[180px] sm:h-[220px] md:h-[260px] object-cover"
                    alt={data.title || "gallery image"}
                    onError={(e) => {
                      console.error(`Failed to load image: ${url}`);
                      e.currentTarget.src = "/fallback-image.jpg";
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>

        {/* BESTSELLERS Button */}
        <div className="flex justify-center mt-8 md:mt-10">
          <a
            className="
              px-6 sm:px-10 
              py-2.5 sm:py-3 
              bg-[#ad2c8f33] 
              text-[#ad2c8f] 
              text-base sm:text-lg 
              tracking-[0.15em] sm:tracking-[0.2em] 
              rounded-full 
              shadow-sm hover:shadow-md transition
            "
          >
            {data.title || "BESTSELLERS"}
          </a>
        </div>
      </div>
    </>
  );
};

export default BestSellersGallery;
